module.exports = __webpack_public_path__ + "img/qrcode-android.fc8df296.svg";